export const isTokenExpired = (): boolean | null => {
  if (typeof window !== "undefined" && window.turnstile?.isExpired) {
    try {
      return window.turnstile.isExpired();
    } catch {
      return null;
    }
  }
  return null;
};

export const getCurrentToken = (): string | null => {
  if (
    typeof window !== "undefined" &&
    window.turnstile?.getResponse &&
    !isTokenExpired()
  ) {
    try {
      return window.turnstile.getResponse();
    } catch {
      return null;
    }
  }
  return null;
};

export function resetToken() {
  if (typeof window !== "undefined" && window.turnstile?.reset) {
    try {
      window.turnstile.reset();
    } catch {
      // No widget rendered (e.g. edit flow) — nothing to reset.
    }
  }
}

export const requestNewToken = () => {
  const event = new CustomEvent("gen-new-turnstile-token", {});
  window.dispatchEvent(event);
};
